import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Box, Button, Tooltip } from "@mui/material";
import { SortDirection } from "../../utils/competitionHelpers";

interface SortButtonProps {
  direction: SortDirection;
  onToggle: () => void;
  labelDesc: string;
  labelAsc: string;
  tooltipDesc: string;
  tooltipAsc: string;
}

/**
 * Reużywalny przycisk sortowania z ikoną i etykietą
 */
export default function SortButton({
  direction,
  onToggle,
  labelDesc,
  labelAsc,
  tooltipDesc,
  tooltipAsc,
}: SortButtonProps) {
  return (
    <Tooltip title={direction === "desc" ? tooltipDesc : tooltipAsc}>
      <Button
        size="small"
        onClick={onToggle}
        startIcon={
          direction === "desc" ? (
            <ArrowDownward fontSize="small" />
          ) : (
            <ArrowUpward fontSize="small" />
          )
        }
        sx={{
          color: "primary.main",
          textTransform: "none",
          fontSize: { xs: "0.75rem", sm: "0.75rem" },
          padding: { xs: "4px 8px", sm: "4px 12px" },
          minWidth: "auto",
          "&:hover": {
            backgroundColor: "action.hover",
          },
          "& .MuiButton-startIcon": {
            marginRight: { xs: 0, sm: 0.5 },
          },
        }}
      >
        <Box
          component="span"
          sx={{
            display: { xs: "none", sm: "inline" },
          }}
        >
          {direction === "desc" ? labelDesc : labelAsc}
        </Box>
      </Button>
    </Tooltip>
  );
}

